import { useAuthStore } from '../store/authStore'

const state = useAuthStore.getState()
const role = state?.userData?.role?.name
const isUser = role === 'user'
const isAdmin = ['admin', 'indianadmin'].includes(role)
const isManager = role === 'manager'
const isIndianAdmin = role === 'indianadmin'

export const checkPermission = (key: string) => {
  const rules: Record<string, boolean> = {
    users_list: isAdmin && !isIndianAdmin,
    managers_sidebar: isAdmin && !isIndianAdmin,
    users_sidebar: isAdmin && !isIndianAdmin,
    user_log_sidebar: isAdmin,
    clients_sidebar: isAdmin || isManager,
    client_view: isAdmin || isManager,
    reports_sidebar: isAdmin,
    reports_funds: isAdmin,
    reports_jobs: isAdmin,
    reports_job_queries: isAdmin,
    reports_logs: role === 'admin',
    funds_sidebar: isUser,
    home: isUser,
    dashboard: !isUser,
    assign_manager: isAdmin && !isIndianAdmin,
    fund_actions: isAdmin && !isIndianAdmin,
    job_actions: isAdmin && !isIndianAdmin,
    clients_funds_search: isManager,
    job_view: isUser,
    job_zip_delete: isAdmin && !isIndianAdmin,
    job_zip_upload: isAdmin || isManager,
    admin_job_view: isAdmin,
    templates_sidebar: isUser,
    login: true,
    admin_login: true,
    forget_password: true,
    top_search: isUser || isIndianAdmin,
    job_details_search: isManager,
    all_funds: isIndianAdmin,
    downloadZip: !isUser,
    sideForm: isUser,
    hide_job_fileUpload: isManager,
    can_delete_file: isAdmin && !isIndianAdmin,
    submit_job: isUser,
    switch_account: isUser,
  }

  return rules[key] ?? false
}
